const gradientTypes = ['hero_linear', 'soft_mesh', 'radial_glow'];
const interactionSources = ['preview', 'tooltip', 'details_modal'];
let visitPath;
let viewedTypes = new Set();

export const beginGradientVisit = (pathname) => {
    if (visitPath !== pathname) {
        visitPath = pathname;
        viewedTypes = new Set();
    }
};

export const claimGradientImpression = (pathname, gradientType) => {
    beginGradientVisit(pathname);
    if (!gradientTypes.includes(gradientType) || viewedTypes.has(gradientType)) return false;
    viewedTypes.add(gradientType);
    return true;
};

export const getGradientContext = (gradientType, stopCount, interactionSource) => ({
    ...(gradientTypes.includes(gradientType) ? { gradient_type: gradientType } : {}),
    stop_count: stopCount,
    ...(interactionSources.includes(interactionSource)
        ? { interaction_source: interactionSource }
        : {}),
});

export const copyGradientWithAnalytics = async (track, copyToClipboard, gradientCss, context) => {
    if (typeof gradientCss !== 'string' || !gradientCss.trim()) return false;
    track('gradient_copy_clicked', context);
    const succeeded = await copyToClipboard({ valueCopied: gradientCss, labelCopied: gradientCss });
    if (succeeded) track('gradient_copy_succeeded', context);
    return succeeded;
};
